export default __webpack_public_path__ + "static/media/smart-makers-anos-finais-gray.0e3f474e.jpg";